// src/router/account.item.router.ts
import type { RouteRecordRaw } from 'vue-router'

export const accountItemRoutes: RouteRecordRaw[] = [
  {
    path: 'account/item',
    name: 'account-item',
    component: () => import('@/views/page/account/item/AccountItemData.vue'),
    meta: { title: 'Account Item' },
  },
  {
    path: 'account/item/trash',
    name: 'account-item-trash',
    component: () => import('@/views/page/account/item/AccountItemData.vue'),
    meta: { title: 'Account Item Trash' },
  },
  {
    path: 'account/item/create/',
    name: 'account-item-create',
    component: () => import('@/views/page/account/item/AccountItemInput.vue'),
    meta: { title: 'Create Account Item' },
  },
  {
    path: 'account/item/:id/edit',
    name: 'account-item-edit',
    component: () => import('@/views/page/account/item/AccountItemInput.vue'),
    meta: { title: 'Edit Account Item' },
  },
]
